// Success Stories Data - Add new images here to display on the website
// Each entry needs: id, imageUrl, title, description (optional)

export const successStories = [
  {
    id: 1,
    imageUrl: "https://customer-assets.emergentagent.com/job_halal-finance-9/artifacts/el0xussj_proof1.png",
    title: "Silver $100 Call - 15% Drop After Our Alert",
    description: "Proof. Timing. Discipline. Silver corrected ~15% on January 30, 2026 after our call.",
  },
  {
    id: 2,
    imageUrl: "https://customer-assets.emergentagent.com/job_halal-finance-9/artifacts/zpd0tih2_proof2.png",
    title: "MU Called Up Nearly 93%",
    description: "From November 4th, 2024 our STRONG buy call for MU performed +93% gain.",
  },
  {
    id: 3,
    imageUrl: "https://customer-assets.emergentagent.com/job_halal-finance-9/artifacts/zjypnh09_proof3.png",
    title: "ASML Called Up Over 50%",
    description: "Long term DCA call for ASML on May 19, 2025 resulted in +50% gain by January 2026.",
  },
  {
    id: 4,
    imageUrl: "https://customer-assets.emergentagent.com/job_halal-finance-9/artifacts/k2iskedg_WhatsApp%20Image%202026-02-01%20at%201.40.28%20PM.jpeg",
    title: "ICS Daily Bot - 2026 Performance Snapshot",
    description: "78.2% success rate with +781.68% total P/PL from July 2025 to Jan 2026. 186 TP hits vs 52 SL hits.",
  },
];

// To add a new success story:
// 1. Upload your image
// 2. Add a new object to the array above with:
//    - id: next sequential number
//    - imageUrl: the URL of your uploaded image
//    - title: headline for the success story
//    - description: brief description of the win
